import { $api } from "@/lib/api-client";

export const useFetchAvailableLand = (projectId: string, type: number) => {
  const result = $api.useQuery("get", "/nft/available/{projectId}", {
    params: {
      path: { projectId: projectId },
      query: { type },
    },
  });

  // openapi-react-query returns { data: WrappedApiResponseDto }
  // Access result.data.data to get the actual response data
  return {
    data: result.data?.data,
    error: result.error,
    isLoading: result.isLoading,
  };
};
